import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import LootBoxForm from './LootBoxForm';
// import { initialValues  } from './initialValues-testing';
import { showLootBoxApi, updateLootBoxApi, clearEditedLootBox } from './lootBoxSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function LootBoxUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.lootBox);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'loot-boxes');
        dispatch(updateLootBoxApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showLootBoxApi({ navigate, id }));

        return () => dispatch(clearEditedLootBox());
    }, []);

    return (
        <LootBoxForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default LootBoxUpdate;
